import { render, staticRenderFns } from "./InTransitOrders.vue?vue&type=template&id=5d346651&scoped=true"
import script from "./InTransitOrders.vue?vue&type=script&lang=js"
export * from "./InTransitOrders.vue?vue&type=script&lang=js"
import style0 from "./InTransitOrders.vue?vue&type=style&index=0&id=5d346651&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d346651",
  null
  
)

export default component.exports